import _ from 'lodash';

// // Static data from tst for testing
// import dataCurrentYear from '../staticData/cy-data.json';
// import dataPreviousYear from '../staticData/py-data.json';

const initialState = {
	performanceData: [],
	monogramData: [],
	prestigeData:[],
	geDistributorData:[],
	documents: null,
	salesAgreementHandBook: null,
	claimFormsDocuments: null,
	fullCatalogDocuments: null,
	priceSheets: null,
	registrationHelpDoc: null,
	// dataCurrentYear,
	// dataPreviousYear
};

export default function resources(state = initialState, action) {
    switch (action.type) {
	    case 'SAVE_PERFORMANCE_DATA':
			const performanceData = state.performanceData;
			performanceData.push(action.data);
	        return { ...state,
	            performanceData
	        };
		case 'SAVE_PRESTIGE_DATA':
			const prestigeData = state.prestigeData;
			prestigeData.push(action.data);
	        return { ...state,
	            prestigeData
	        };
		case 'SAVE_MONOGRAM_DATA':
			const monogramData = state.monogramData;
			monogramData.push(action.data);
	        return { ...state,
	            monogramData
        	};
		case 'SAVE_GE_DISTRIBUTOR_DATA':
			const geDistributorData = state.geDistributorData;
			geDistributorData.push(action.data);
	        return { ...state,
	            geDistributorData
        	};
		case 'SAVE_DOCUMENTS':
			return { ...state,
				documents: action.data
			}
		case 'SAVE_PRICE_SHEETS':
			return { ...state,
				priceSheets: action.data
			}
		case 'SAVE_REGISTRATION_HELP_DOCUMENTS':
			return { ...state,
				registrationHelpDoc: action.data
			}
		case 'SAVE_CLAIM_FORMS_DOCUMENTS':
			return { ...state,
				claimFormsDocuments: action.data
			}
		case 'SAVE_FULL_CATALOG_DOCUMENTS':
			return { ...state,
				fullCatalogDocuments: action.data
			}
		case 'SAVE_SALES_AGREEMENT_HANDBOOK':
			var salesAgreementData = [];
			if(action.data && action.data.responseObject){
				salesAgreementData = _.sortBy(action.data.responseObject, ['file']);
			}
			return { ...state,
				salesAgreementHandBook: salesAgreementData
			}
		case 'RESET_RESOURCES_REDUCERS':
			return initialState;
	    default:
	        return state;
    }
}



// WEBPACK FOOTER //
// ./src/App/redux/reducers/resources.js